import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faLocationDot } from '@fortawesome/free-solid-svg-icons';

import '../../utils/styles/Contacts.css';

function Contacts() {
    return (
        <div className="container">
            <p className="title-3">Contactez-nous</p>
            <div>
                <p className="title">Assemblée Générale des Étudiant·es</p>
                <div className="contacts-infos">
                    <p>
                        <FontAwesomeIcon
                            icon={faClock}
                            size="lg"
                            className="fa-fw"
                        />{' '}
                        Lundi de 12h à 16h | Mardi-Vendredi de 9h à 16h
                    </p>
                    <p>
                        <FontAwesomeIcon
                            icon={faLocationDot}
                            size="lg"
                            className="fa-fw"
                        />{' '}
                        Rue Bruno 9, 5000 Namur
                    </p>
                </div>
            </div>
            <div>
                <p className="title">Qui contacter ?</p>
                <p className="paragraph">
                    Si tu as des questions sur l'AGE, son fonctionnement, tes
                    études ou la vie étudiante sur le campus de Namur, n'hésite
                    pas à nous contacter !
                </p>
                <div className="contacts-contacts">
                    <p>
                        Permanent :{' '}
                        <a href="tel:+3281725087">+32 81 72 50 87</a> |{' '}
                        <a href="mailto: age@unamur.be">age@unamur.be</a>
                    </p>
                    <p>
                        Président :{' '}
                        <a href="mailto: president@age-namur.be">
                            president@age-namur.be
                        </a>
                    </p>
                    <p>
                        Vice-Président Conseil Etudiant :{' '}
                        <a href="mailto: vice-president-politique@age-namur.be">
                            vice-president-politique@age-namur.be
                        </a>
                    </p>
                    <p>
                        Vice-Président Animation :{' '}
                        <a href="mailto: vice-president-animation@age-namur.be">
                        vice-president-animation@age-namur.be
                        </a>
                    </p>
                </div>
            </div>
            <div>
                <p className="title">L'équipe de développement</p>
                <p className="paragraph">
                    Cette application a été réalisée par l'équipe technologique
                    de l'AGE. Vous pouvez nous faire parvenir vos retours,
                    signalements de bugs ou suggestions d'amélioration via{' '}
                    <a href="mailto:technologie@age-namur.be">
                        cette adresse mail
                    </a>
                    . Tout retour sera analysé afin d'améliorer au mieux
                    l'application et de répondre aux besoins des étudiant·es.
                    <br /> <br />© 2025 Assemblée Générale des Étudiant·es de
                    l'UNamur
                </p>
            </div>
        </div>
    );
}

export default Contacts;
